import React from "react";

const DefaultProviderChat = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "80%",
        minHeight: "80vh",
        textAlign: "center",
        color: "#666",
        padding: "20px",
      }}
    >
      <div>
        <h3>Welcome to Chat</h3>
      </div>
    </div>
  );
};

export default DefaultProviderChat;
